<template>
  <a-cascader
      v-model:value="stationSelect"
      :allowClear="false"
      :fieldNames="{ label: 'policeAreaName', value: 'policeAreaCode', children: 'children' }"
      :load-data="stationLoadData"
      :options="stationOptions"
      :placeholder="placeholder"
      style="width: 100%"
      @change="changeSelect"
      @popup-visible-change="getStationData"
  ></a-cascader>
</template>

<script>
import {onMounted, reactive, toRefs} from "vue";
import {getStationList} from "@/api/api";

export default {
  props: {
    placeholder: {
      default: "请选择所属派出所",
    },
    areaValue: {
      default: null,
    },
  },
  setup(props, context) {
    let area = reactive({
      stationSelect: [],
      placeholder: props.placeholder,
      stationOptions: [], //区域选项数据
      getStationData() {
        if (!area.stationOptions.length) {
          getStationList({
            policeAreaCode: 32,
          }).then((res) => {
            area.stationOptions = res.data.map((item) => {
              item.isLeaf = false;
              return item;
            });
          });
        }
      },
      stationLoadData(params) {
        const targetOption = params[params.length - 1];
        targetOption.loading = true;
        let policeAreaCode = targetOption.policeAreaCode;
        console.log(policeAreaCode.length > 8)
        getStationList({
          policeAreaCode: policeAreaCode,
        }).then((res) => {
          targetOption.children = res.data.map((item) => {
            item.isLeaf = policeAreaCode.length > 5 ? true : false;
            return item;
          });
          targetOption.loading = false;
        });
      },
      changeSelect(value, selectedOption) {
        const params = {
          p_code: value[0] ? value[0] : "",
          c_code: value[1] ? value[1] : "",
          a_code: value[2] ? value[2] : "",
          p_name: selectedOption[0] ? selectedOption[0].policeAreaName : "",
          c_name: selectedOption[1] ? selectedOption[1].policeAreaName : "",
          a_name: selectedOption[2] ? selectedOption[2].policeAreaName : "",
        };
        console.log(area.stationSelect);
        context.emit("changeStation", params);
      },
    });

    onMounted(() => {
    });

    return {
      ...toRefs(area),
    };
  },
};
</script>

<style>
</style>
